module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-17.4845bf4d.jpg";